<template>
  <div class="container-fluid">
    <div class="project-units">
      <div
        class="d-flex gap-3 justify-content-between mb-3 align-items-center project-header-stats flex-wrap"
      >
        <div class="col">
          <h3 class="mb-3">{{ project.name }}</h3>
        </div>
        <div class="d-flex gap-3 justify-content-between flex-wrap">
          <div class="total-logs">
            <h5 class="font-bold">الوحدات</h5>
            <br>

            <h6>{{ recievedCashFromUnits.toLocaleString("en-US") }} </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">الأرض</h5>
            <br>

            <h6>{{ totalEarth.toLocaleString("en-US") }} </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">المصروفات</h5>
            <br>

            <h6>{{ totalExpenses.toLocaleString("en-US") }} </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">الصافي</h5>
            <br>
            <h6>
              {{
                (
                  recievedCashFromUnits -
                  totalExpenses -
                  totalEarth
                ).toLocaleString("en-US")
              }}
              
            </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">توزيع ارباح</h5>
            <br>

            <h6>
              {{
                (
                  project.profit
                ).toLocaleString("en-US")
              }}
              
            </h6>
          </div>
          
          <div class="total-logs">
            <h5 class="font-bold">باقي الارباح</h5>
            <br>

            <h6 v-if="(recievedCashFromUnits -
                  totalExpenses -
                  totalEarth)>0">
              {{
                (
                  recievedCashFromUnits -
                  totalExpenses -
                  totalEarth-project.profit
                ).toLocaleString("en-US")
              }}
              
            </h6>
            <h6 v-else>0</h6>
          </div>

        </div>
      </div>

      <b-tabs v-model="tabIndex" pills>
        <b-tab title="الأرض" :name="1">
          <div class="logs mt-3">
            <!-- <div
              class="d-flex gap-2 flex-row-reverse mb-1"
              style="margin-top: -100px"
            >
              <div class="total-logs">
                <h5 class="font-bold">الإجمالي</h5>
                <h6>{{ earthTotal }} </h6>
              </div>
            </div> -->
            <div class="d-flex flex-row-reverse mb-3">
              <el-button class="blue-btn" @click="openAddNewExpense = true">
                إضافة تكلفة للارض
              </el-button>
            </div>
            <el-table class="table-mobile" :data="expenses" style="width: 100%">
              <el-table-column prop="comment" label="الوصف">
                <template slot-scope="scope">
                  <span class="label">الوصف</span>
                  <div>
                    {{ scope.row.comment }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" label="المبلغ">
                <template slot-scope="scope">
                  <span class="label">المبلغ</span>
                  <div>
                    <h6>
                      {{ scope.row.cost }}
                    </h6>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="200" label="التاريخ">
                <template slot-scope="scope">
                  <span class="label">التاريخ</span>
                  <div>
                    {{
                      scope.row.created_at | moment(" Do / MM / YYYY | h:mm A")
                    }}
                  </div>
                  <!-- $moment()
                      .locale("ar")
                      .utc(false)
                      .format("llll") -->
                </template>
              </el-table-column>
              <el-table-column width="100" label="الاجراء">
                <template slot-scope="scope">
                  <span class="label">الاجراء</span>
                  <el-row>
                    <el-button
                      v-if="accessLinks('delete_expense')"
                      type="primary"
                      icon="el-icon-edit"
                      title="تعديل"
                      size="mini"
                      class="mr-2"
                      @click.native.prevent="editItem(scope)"
                    >
                      تعديل
                    </el-button>
                    <!-- <el-popconfirm
                  v-if="accessLinks('update_expense')"
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد مسح المصروف؟"
                  @confirm="deleteItem(scope)"
                >
                  <div slot="reference">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      title="مسح"
                      size="mini"
                      circle
                    ></el-button>
                  </div>
                </el-popconfirm>
                 -->
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </b-tab>
        <b-tab title="الوحدات" :name="2" active>
          <div class="locations__header d-flex mt-3">
            <div style="flex: 1">
              <el-input
                @input="searchInUnits"
                prefix-icon="el-icon-search"
                placeholder="بحث في الوحدات"
                v-model="search"
              ></el-input>
            </div>
            <div>
              <el-button
                type="primary"
                class="blue-btn"
                @click="openAddUnitModel = true"
              >
                إضافة
              </el-button>
            </div>
          </div>

          <div class="row" v-if="units.length > 0">
            <div v-for="unit in units" :key="unit.id" class="col-md-4">
              <div
                class="unit"
                style="position: relative"
               
              >
                <el-button
                  @click.stop="
                    (openUpdateUnitModel = true), (updateUnit = { ...unit })
                  "
                  style="position: absolute; top: 5px; left: 5px; padding: 5px"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Icon"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  >
                    <rect
                      id="Area"
                      width="20"
                      height="20"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g
                      id="Icon-2"
                      data-name="Icon"
                      transform="translate(1.566 1.566)"
                    >
                      <path
                        id="Path"
                        d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                        transform="translate(0.101 -1.566)"
                        fill="none"
                        stroke="#919efa"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <path
                        id="Path-2"
                        data-name="Path"
                        d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                        transform="translate(-6.667 -1.566)"
                        fill="none"
                        stroke="#919efa"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </svg>
                </el-button>
                <el-button
                  @click="$router.push(`/project_units/${unit.id}`)"
                  style="position: absolute; top: 5px; left: 50px; padding: 8px"
                  icon="el-icon-search"
                     icon-color="red"
                     plain
                       type="primary"
                >
                
                </el-button>

                <div class="d-flex head">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:svgjs="http://svgjs.com/svgjs"
                      version="1.1"
                      width="25"
                      height="25"
                      x="0"
                      y="0"
                      viewBox="0 0 426.667 426.667"
                      style="enable-background: new 0 0 512 512"
                      xml:space="preserve"
                    >
                      <g>
                        <g xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <path
                              d="M362.667,384V0H64v384H21.333v42.667h384V384H362.667z M192,42.667h42.667v42.667H192V42.667z M192,128h42.667v42.667H192    V128z M192,213.333h42.667V256H192V213.333z M149.333,256h-42.667v-42.667h42.667V256z M149.333,170.667h-42.667V128h42.667    V170.667z M149.333,85.333h-42.667V42.667h42.667V85.333z M256,384h-85.333v-42.667c0-23.467,19.2-42.667,42.667-42.667    S256,317.867,256,341.333V384z M320,256h-42.667v-42.667H320V256z M320,170.667h-42.667V128H320V170.667z M320,85.333h-42.667    V42.667H320V85.333z"
                              fill="#000000"
                              data-original="#000000"
                            />
                          </g>
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                      </g>
                    </svg>
                  </div>
                  <div>
                    <h5>{{ unit.description }}</h5>
                  </div>
                </div>
                <h6 class="d-flex" style="gap: 5px">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:svgjs="http://svgjs.com/svgjs"
                      version="1.1"
                      width="20"
                      height="20"
                      x="0"
                      y="0"
                      viewBox="0 0 501.9 501.9"
                      style="enable-background: new 0 0 512 512"
                      xml:space="preserve"
                      class=""
                    >
                      <g>
                        <g xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <path
                              d="M501.8,270.1c-0.6-13.9-14.2-25-40.5-33c-20.4-6.1-46.3-9.8-74.3-10.4V120c-0.1-1.8-0.6-3.5-1.5-5    c-2.8-12.1-16.3-21.9-40.2-29.1c-22.5-6.8-51.9-10.5-82.8-10.5c-30.8,0-59.9,3.7-82,10.5c-18.1,5.6-39.8,16-39.8,33.9    c0,1.1,0.1,2.2,0.3,3.3l1.1,45.6c-65-12.4-127.7,30.3-140,95.2C0.7,271.3,0,278.7,0,286.2c0,66,53.7,119.7,119.7,119.7    c27.5,0,54.1-9.4,75.4-26.8c18.7,4.4,40.7,6.8,64,7c5.1,27.7,65.1,40.4,121,40.4c30.8,0,59.9-3.8,82-10.7    c18.1-5.6,39.8-16.1,39.8-34V272C501.9,271.4,501.9,270.7,501.8,270.1z M366.1,175.3c0,1.3-4.8,8.2-26.5,14.8    c-20.3,6.1-48.4,9.7-77,9.7c-24.7,0-48.9-2.6-68.1-7.5c-0.3-0.1-0.5-0.1-0.8-0.2c-9.5-7.5-20-13.5-31.3-17.7l-0.7-28.2    c6.9,3.5,14.1,6.3,21.6,8.3c21.7,6.3,49.8,9.7,79.3,9.7c30.8,0,60.3-3.7,82.8-10.5c7.5-2.2,14.8-5.1,21.7-8.7v26.2    C366,172.6,366.1,173.9,366.1,175.3z M186.5,105.2c20.2-6.2,47.2-9.7,76-9.7c28.6,0,56.7,3.5,77,9.7c21.7,6.6,26.5,13.4,26.5,14.7    c0,1.4-4.9,8.3-26.6,14.8c-20.3,6.1-48.3,9.6-76.9,9.6c-27.6,0-53.8-3.2-73.7-9c-21.5-6.2-27.5-13-28-15.2c0-0.2-0.1-0.2-0.1-0.2    C160.8,118,165.4,111.6,186.5,105.2z M186.8,360C146.1,397,83,394.1,46,353.4s-34.1-103.8,6.6-140.8    c18.3-16.7,42.3-25.9,67.1-25.9c10,0,19.9,1.5,29.5,4.4c34.7,10.8,60.8,39.6,68.2,75.1c1.3,6.6,2,13.4,2,20.1    C219.5,314.4,207.6,341.1,186.8,360z M212.2,362.2c8.1-9.9,14.6-21,19.2-32.9c8.5,0.7,17.3,1.2,26.5,1.3v1.8l0.6,33.9    C243,366.1,227.5,364.7,212.2,362.2z M238.9,274.4c5.8,0.4,11.9,0.6,18.1,0.7l0.6,35.4c-7-0.1-13.9-0.4-20.5-0.9    c1.5-7.7,2.3-15.6,2.3-23.4C239.4,282.3,239.2,278.4,238.9,274.4z M263.5,255.2c-0.3,0-0.7,0-1,0c-9.6,0-18.9-0.4-27.5-1    c-3.8-13.4-9.8-26-17.9-37.2c15,1.9,30.1,2.9,45.3,2.9c30.9,0,60.4-3.7,82.9-10.5c7.5-2.2,14.7-5.1,21.6-8.6V227    C324,228.2,279.9,237.2,263.5,255.2z M276.7,271.1c0-0.1,0-0.2,0.1-0.4c0.9-2.7,8-9.3,28.7-15.1c19.4-5.5,44.7-8.5,71.3-8.5h1.7    c28.6,0,56.6,3.3,77,9.5c21.3,6.4,26.3,13,26.4,14.5v0.1c-0.1,1.5-5.1,8.4-27.3,15c-20.5,6.1-47.5,9.4-76,9.4    c-27.6,0-53.8-3.2-73.7-8.9c-21.5-6.2-27.4-13.1-28-15.2C276.7,271.1,276.7,271.1,276.7,271.1z M456.3,396.8    c-20.2,6.3-47.3,9.8-76.1,9.8c-28.9,0-55.9-3.4-75.9-9.5c-21.1-6.5-25.5-13.2-25.5-14.7c0-0.1,0-0.1,0-0.2l-0.5-29    c8,3.9,16.3,6.9,24.9,9.1c21,5.5,47.7,8.6,75.1,8.6c30.9,0,60.2-3.7,82.6-10.5c7.3-2.2,14.3-5.1,21-8.5v30h0.1    C482,383.3,477.4,390.2,456.3,396.8z M482.1,323.2H482c0,1-0.6,2.2-0.6,3.3c0,1.4-4.7,8.2-26.3,14.8c-20.5,6.2-47.8,9.6-76.7,9.6    c-55.4,0-92.7-12.5-100.5-22.2l-0.1-8.4l-0.4-23c7,3.5,14.3,6.3,21.8,8.4c21.7,6.3,49.8,9.7,79.3,9.7c30.4,0,59.4-3.6,81.7-10.2    c7.6-2.1,14.9-5,21.9-8.6V323.2z"
                              fill="#000000"
                              data-original="#000000"
                              class=""
                            />
                          </g>
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <path
                              d="M156.1,300.4c-4.6-16.3-19.5-27.5-36.4-27.5c-9.8,0-17.8-7.9-17.8-17.7c0.1-9.9,8-17.8,17.8-17.8s17.8,8,17.8,17.8    c0,5.5,4.5,10,10,10s10-4.5,10-10c0-16.9-11.2-31.8-27.5-36.4v-4.5c0-5.5-4.5-10-10-10s-10,4.5-10,10v4.3    c-20.1,5.4-32.1,26.1-26.7,46.2c4.4,16.5,19.3,28,36.4,28c9.8,0,17.8,7.9,17.8,17.7s-7.9,17.8-17.7,17.8s-17.8-7.9-17.8-17.7    c0-5.5-4.5-10-10-10s-10,4.5-10,10c0.1,17.1,11.5,32,28,36.5v8.7c0,5.5,4.5,10,10,10s10-4.5,10-10V347    C150.1,341.3,161.8,320.5,156.1,300.4z"
                              fill="#000000"
                              data-original="#000000"
                              class=""
                            />
                          </g>
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                        <g xmlns="http://www.w3.org/2000/svg"></g>
                      </g>
                    </svg>
                  </div>
                  <div>
                    {{ unit.cost.toLocaleString("en-US") }}
                  </div>
                </h6>
                <div class="d-flex gap-3">
                  <h6>المبلغ المستلم :</h6>
                  <h6>{{ calcUnitPaied(unit).toLocaleString("en-US") }}</h6>
                </div>
                <div class="unit-footer">
                  <div>
                    <span v-if="unit.startedAt">
                      {{ $moment(unit.startedAt).locale("ar").fromNow() }}
                    </span>
                  </div>
                  <span v-if="unit.startedAt" style="margin-right: 20%">
                    {{ unit.startedAt }}
                  </span>
                  <div>
                    <span class="status danger" v-if="unit.client_id == null"
                      >لم تسلم</span
                    >
                    <span class="status success" v-else>تم تسلم</span>
                  </div>
                  <div >
                     <el-popconfirm 
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + unit.description + ' ؟'"
                    @confirm="destroy(unit)"
                  >
                    <div slot="reference">
                      <el-button
                        title="حذف"
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                      ></el-button>
                    </div>
                  </el-popconfirm>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-data-img" v-else>
            <NoData />
          </div>
        </b-tab>
        <b-tab :name="3" title="المصروفات">
          <div class="logs mt-3">
            <section class="d-flex gap-3 justify-content-between">
              <div style="width: 100%">
                <el-input
                  class="search-in-expenses"
                  placeholder="بحث في المصروفات"
                  v-model="searchInExpenses"
                />
              </div>
              <div class="mb-3">
                <el-button class="blue-btn" @click="openAddNewExpense2 = true">
                  إضافة مصروف
                </el-button>
              </div>
            </section>

            <div
              class="d-flex flex-row-reverse mb-3 mt-0"
              style="margin-top: -100px"
            >
              <div class="total-logs">
                <h5 class="font-bold">الإجمالي</h5>
                <h6>{{ calcLogsAmount.toLocaleString("en-US") }} </h6>
              </div>
            </div>
            <el-table class="table-mobile" :data="filteredLogs" style="width: 100%">
              <el-table-column width="200" label="الحالة" data-label="الحالة">
                <template slot-scope="scope">
                  <span class="label">الحالة</span>
                  <div>
                    {{
                      $moment(scope.row.created_at)
                        .locale("ar")
                        .utc(false)
                        .format("llll")
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="الوصف" data-label="الوصف">
                <template slot-scope="scope">
                  <span class="label">الوصف</span>
                  <div>
                    {{ scope.row.description }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" label="المبلغ" data-label="المبلغ">
                <template slot-scope="scope">
                  <span class="label">المبلغ</span>
                  <div>
                    <h6 class="text-danger" v-if="scope.row.type == 0">
                      - {{ scope.row.amount.toLocaleString("en-US") }}
                    </h6>
                    <h6 class="text-success" v-if="scope.row.type == 1">
                      + {{ scope.row.amount.toLocaleString("en-US") }}
                    </h6>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة وحدة جديدة"
      :active.sync="openAddUnitModel"
    >
      <div class="popup-calender">
        <el-form :model="addUnit" ref="addUnit">
          <h6 class="mb-1">وصف الوحدة</h6>
          <el-form-item
            prop="description"
            :rules="[{ required: true, message: 'الوصف مطلوب' }]"
          >
            <el-input
              v-model="addUnit.description"
              placeholder="وصف الوحدة"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">
            سعر الوحدة
            <span class="mr-5" v-if="addUnit.cost > 0"
              >( {{ convertNumber(addUnit.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[{ required: true, message: 'السعر مطلوب' }]"
          >
            <el-input
              type="number"
              @focus="$event.target.select()"
              v-model="addUnit.cost"
              placeholder="سعر الوحدة"
            ></el-input>
          </el-form-item>
          <h6 class="mb-1">تاريخ البيع</h6>
          <el-form-item
            prop="startedAt"
            :rules="[{ required: true, message: ' تاريخ البيع مطلوب  ' }]"
          >
            <el-date-picker
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="تاريخ البيع "
              v-model="addUnit.startedAt"
            >
            </el-date-picker>
          </el-form-item>
          <div class="row">
            <div class="col-md-6">
              <div>
                <el-form-item
                  prop="clientType"
                  :rules="[{ required: true, message: 'نوع العميل مطلوب' }]"
                >
                  <el-radio v-model="addUnit.clientType" label="newClient"
                    >عميل جديد</el-radio
                  >
                </el-form-item>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <el-form-item
                  prop="clientType"
                  :rules="[{ required: true, message: 'نوع العميل مطلوب' }]"
                >
                  <el-radio v-model="addUnit.clientType" label="oldClient"
                    >عميل قديم</el-radio
                  >
                </el-form-item>
              </div>
            </div>
          </div>

          <template v-if="addUnit.clientType == 'newClient'">
            <h6 class="mb-1">اسم العميل</h6>
            <el-form-item
              prop="name"
              :rules="[{ required: true, message: 'الاسم مطلوب' }]"
            >
              <el-input placeholder="الاسم" v-model="addUnit.name"></el-input>
            </el-form-item>

            <h6 class="mb-1">الموبايل</h6>
            <el-form-item
              prop="phone"
              :rules="[{ required: true, message: 'الموبايل مطلوب' }]"
            >
              <el-input placeholder="الهاتف" v-model="addUnit.phone"></el-input>
            </el-form-item>

            <h6 class="mb-1">التليفون</h6>
            <el-form-item prop="mobile">
              <el-input
                placeholder="الموبايل"
                v-model="addUnit.mobile"
              ></el-input>
            </el-form-item>

            <h6 class="mb-1">العنوان</h6>
            <el-form-item prop="address">
              <el-input
                placeholder="العنوان"
                v-model="addUnit.address"
              ></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <h6 class="mb-1">بحث في العملاء</h6>
            <el-form-item
              prop="client_id"
              :rules="[{ required: true, message: 'اختر عميل' }]"
            >
              <el-select
                style="width: 100%"
                placeholder="اختر عميل"
                v-model="addUnit.client_id"
              >
                <el-option
                  v-for="(client, index) in clients"
                  :key="index"
                  :value="client.id"
                  :label="client.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <h6 class="mb-1">
            مقدم الوحدة
            <span class="mr-5" v-if="addUnit.down_payment > 0"
              >( {{ convertNumber(addUnit.down_payment) }} )</span
            >
          </h6>
          <el-form-item prop="down_payment">
            <el-input
              type="number"
              @focus="$event.target.select()"
              placeholder=" مقدم الوحدة"
              v-model="addUnit.down_payment"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addUnit')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="تعديل وحدة "
      :active.sync="openUpdateUnitModel"
    >
      <div class="popup-calender">
        <el-form :model="updateUnit" ref="updateUnit">
          <h6 class="mb-1">وصف الوحدة</h6>
          <el-form-item
            prop="description"
            :rules="[{ required: true, message: 'الوصف مطلوب' }]"
          >
            <el-input
              v-model="updateUnit.description"
              placeholder="وصف الوحدة"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">
            سعر الوحدة
            <span class="mr-5" v-if="updateUnit.cost > 0"
              >( {{ convertNumber(updateUnit.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[{ required: true, message: 'السعر مطلوب' }]"
          >
            <el-input
              v-model="updateUnit.cost"
              placeholder="سعر الوحدة"
            ></el-input>
          </el-form-item>
          <h6 class="mb-1">تاريخ البيع</h6>
          <el-form-item
            prop="startedAt"
            :rules="[{ required: true, message: ' تاريخ البيع مطلوب  ' }]"
          >
            <el-date-picker
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="تاريخ البيع "
              v-model="updateUnit.startedAt"
            >
            </el-date-picker>
          </el-form-item>
          <h6 class="mb-1">
            مقدم الوحدة
            <span class="mr-5" v-if="updateUnit.cost > 0"
              >( {{ convertNumber(updateUnit.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[{ required: true, message: 'مقدم مطلوب' }]"
          >
            <el-input
              v-model="updateUnit.down_payment"
              placeholder="مقدم الوحدة"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div>
              <el-button
                type="primary"
                @click="onSubmitUpdateUnit('updateUnit')"
              >
                تعديل
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="إضافة تكلفة للارض "
      :active.sync="openAddNewExpense"
    >
      <div class="popup-calender">
        <el-form :model="addNewExpense" ref="addExpense">
          <h6 class="mb-1">
            القيمة

            <span class="mr-5" v-if="addNewExpense.cost"
              >( {{ convertNumber(addNewExpense.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[
              { required: true, message: 'قيمة التكلفة مطلوبة' },
              { type: 'number', message: 'يجب ان يكون رقم' },
            ]"
          >
            <el-input v-model.number="addNewExpense.cost"></el-input>
          </el-form-item>

          <h6 class="mb-1">التعليق</h6>
          <el-form-item
            prop="comment"
            :rules="[{ required: true, message: ' التعلق مطلوب' }]"
          >
            <el-input
              type="textarea"
              v-model="addNewExpense.comment"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="addExpense()">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="إضافة مصروف للمشروع  "
      :active.sync="openAddNewExpense2"
    >
      <div class="popup-calender">
        <el-form :model="addNewExpense2" ref="addExpense2">
          <h6 class="mb-1">
            القيمة
            <span class="mr-5" v-if="addNewExpense2.cost"
              >( {{ convertNumber(addNewExpense2.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[{ required: true, message: 'قيمة التكلفة مطلوبة' }]"
          >
            <el-input type="number" v-model="addNewExpense2.cost"></el-input>
          </el-form-item>

          <h6 class="mb-1">التعليق</h6>
          <el-form-item
            prop="comment"
            :rules="[{ required: true, message: ' التعلق مطلوب' }]"
          >
            <el-input
              type="textarea"
              v-model="addNewExpense2.comment"
            ></el-input>
          </el-form-item>

          <h6>وصف المصروف</h6>
          <el-form-item
            prop="category_id"
            :rules="[{ required: true, message: 'وصف المصروف مطلوب' }]"
          >
            <el-select
              searchable
              @focus="index = 0"
              class="mt-2 col-12 p-0"
              v-model="addNewExpense2.category_id"
              placeholder=". "
            >
              <el-option
                v-for="item in categories"
                :key="item.id"
                :label="item.description"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="addExpense2()">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <el-dialog
      :fullscreen="true"
      title="تعديل بيانات المصروف"
      :visible.sync="editFormVisible"
      v-if="selectedExpenses"
    >
      <el-form :model="selectedExpenses">
        <el-row :gutter="10">
          <el-col :xl="3" :lg="3" :md="6" :sm="12">
            <el-form-item label="المبلغ">
              <el-input
                type="number"
                v-model="selectedExpenses.cost"
                autocomplete="off"
                @focus="$event.target.select()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="6" :sm="12">
            <el-form-item label="التعليق ">
              <input
                class="form-control"
                v-model="selectedExpenses.comment"
                autocomplete="off"
                @focus="$event.target.select()"
              />
            </el-form-item>
          </el-col>
          <el-col :xl="3" :lg="3" :md="6" :sm="12">
            <el-form-item label="المستلم ">
              <el-input
                v-model="selectedExpenses.for_who"
                autocomplete="off"
                @focus="$event.target.select()"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="update">حفظ التعديلات</el-button>
        <el-button class="mr-3" @click="editFormVisible = false"
          >إلغاء</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
import NoData from "@/components/NoData.vue";
export default {
  components: { NoData },
  computed: {
    filteredLogs: function () {
      return this.logs.filter((ele) => {
        return ele.description.includes(this.searchInExpenses);
      });
    },

    calcLogsAmount() {
      let totalLogsAmount = 0;
      this.filteredLogs.forEach((ele) => {
        if (ele.type == 1) {
          totalLogsAmount += Number(ele.amount);
        } else if (ele.type == 0) {
          totalLogsAmount -= Number(ele.amount);
        }
      });
      return totalLogsAmount;
    },
  },
  created() {
    this.getProjectWithUnits();
    this.projectExpenses();
    this.getCategories();
    this.getProjectDetails();
    this.getClients();
  },
  data() {
    return {
      totalUnitsCosts: 0,
      totalEarth: 0,
      totalExpenses: 0,
      finalCalc: 0,
      editFormVisible: false,
      selectedExpenses: null,
      earthTotal: 0,
      searchInExpenses: "",
      tabIndex: 2,
      openAddNewExpense: false,
      openAddNewExpense2: false,
      openUpdateUnitModel: false,
      updateUnit: {},
      project: {},
      units: [],
      addNewExpense: {},
      addNewExpense2: {},
      allUnits: [],
      search: "",
      openAddUnitModel: false,
      addUnit: {
        clientType: "newClient",
        client_id: null,
        down_payment: 0,
      },
      logs: [],
      totalLogsAmount: 0,
      expenses: [],
      categories: [],
      updateUnitModel: false,
      currUnit: {},
      projectDetails: {},
      recievedCashFromUnits: 0,
      clients: [],
    };
  },
  methods: {
     destroy(unit) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
                axiosApi
                  .delete("project_units/" + unit.id)
                  .then(res => {
                   
                      this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم حذف الوحده بنجاح",
              });
              setTimeout(() => {
                    location.reload();
                
              }, 1000);
                  })
                  .catch(e => {
                    
                    console.log(e);
                  }) .finally(() => loading.close());
            
        
      
    },
    convertNumber(val) {
      if (val > 0) {
        return Number(val).toLocaleString("en-US");
      } else {
        return "";
      }
    },
    getClients() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/clients`)
        .then((res) => {
          this.clients = res.data;
        })
        .finally(() => loading.close());
    },
    calcUnitPaied(unit) {
      console.log(unit);
      let calc = unit.down_payment;
      unit.unit_installment.map((ele) => {
        calc += +ele.paied;
      });
      return calc;
    },
    async getProjectDetails() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });

      try {
        let res = await axiosApi.get(
          `/projects-details/${this.$route.params.id}`
        );
        console.log(res.data);
        this.allUnits = res.data.units;
        this.units = [...res.data.units];

        this.recievedCashFromUnits = 0;
        this.units.forEach((ele) => {
          let downPayment = +ele.down_payment;
          ele.unit_installment.forEach((ele2) => {
            downPayment += +ele2.paied;
          });
          this.recievedCashFromUnits += +downPayment;
        });
      } finally {
        loading.close();
      }
    },
    getCategories() {
      axiosApi
        .get("categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },

    projectExpenses() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });

      axiosApi
        .get(`/project_expenses/${this.$route.params.id}`)
        .then((res) => {
          this.expenses = res.data;

          this.earthTotal = 0;
          this.expenses.forEach((ele) => {
            this.earthTotal += +ele.cost;
          });

          this.totalEarth = this.earthTotal;
        })
        .finally(() => loading.close());
    },
    addExpense() {
      this.$refs.addExpense.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/expenses`, {
              project_id: this.$route.params.id,
              ...this.addNewExpense,
              category_id: 1,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.projectExpenses();
              this.addNewExpense = {};
              this.openAddNewExpense = false;
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    addExpense2() {
      this.$refs.addExpense2.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post("/expenses", {
              ...this.addNewExpense2,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.openAddNewExpense2 = false;
              this.getProjectWithUnits();
              this.getProjectDetails();
              this.addNewExpense2 = {};
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المصروف بنجاح",
                type: "success",
                duration: 1500,
              });
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    onSubmitUpdateUnit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });

          axiosApi
            .put(`/project_units/${this.updateUnit.id}`, {
              ...this.updateUnit,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.getProjectWithUnits();
              this.getProjectDetails();
              this.openUpdateUnitModel = false;
            })
            .finally(() => loading.close());
        }
      });
    },
    onSubmit(projectName) {
      this.$refs[projectName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          if (this.addUnit.clientType == "newClient") {
            this.addUnit.client_id = null;
          }
          axiosApi
            .post(`/project_units`, {
              ...this.addUnit,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.addUnit = {
                clientType: "newClient",
                client_id: null,
              };
              this.openAddUnitModel = false;

              this.$router.go(0);
              // this.getProjectWithUnits();
              // this.getProjectDetails();
            })
            .catch((e) => {
              if (e.response.status == 400) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: ` عفوا تاكد من بيانات الوحده ورقم الهاتف موجود لعميل اخر`,
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    searchInUnits() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.units = this.allUnits.filter((ele) => {
        return ele.description.includes(this.search);
      });
      // loading.close();
    },

    deleteItem(scope) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`expenses/${scope.row.id}`)
        .then(() => {
          this.projectExpenses();

          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم مسح بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
      console.log("delete", scope.row);
    },
    editItem(scope) {
      this.selectedExpenses = scope.row;
      this.editFormVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.selectedExpenses.cost = parseFloat(this.selectedExpenses.cost);
      axiosApi
        .put(`expenses/${this.selectedExpenses.id}`, this.selectedExpenses)
        .then(() => {
          this.projectExpenses();

          this.editFormVisible = false;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم تحديث بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          if (e.response.status == 403) {
            this.$notify.error({
              title: "حدث خطأ",
              message: ` عفوا المبلغ غير متوفر . الخزينه بها فقط  ${e.response.data.balance}`,
              duration: 1500,
            });
          } else {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المطلوبة",
              duration: 1500,
            });
          }
        })
        .finally(() => loading.close());
    },

    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
    getProjectWithUnits() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/projects/${this.$route.params.id}`)
        .then((res) => {
          this.project = res.data;
          // this.allUnits = this.project.units;
          this.logs = this.project.logs;
          // this.totalLogsAmount = 0;
          // this.logs.forEach((ele) => {
          //   if (ele.type == 1) {
          //     this.totalLogsAmount += Number(ele.amount);
          //   } else if (ele.type == 0) {
          //     this.totalLogsAmount -= Number(ele.amount);
          //   }
          // });

          // this.totalUnitsCosts = this.project.units.reduce((prev,curr) => {
          //   let sum = 0;
          //   sum += !isNaN(+prev.cost) ? +prev.cost : +prev;
          //   sum += !isNaN(+curr.cost) ? +curr.cost : +curr;
          //   return sum;
          // }, {cost: 0})

          this.totalUnitsCosts = 0;
          this.project.units.forEach((ele) => {
            this.totalUnitsCosts += Number(ele.cost);
          });

          this.totalExpenses = 0;
          this.project.logs.forEach((ele) => {
            if (ele.type == 1) {
              this.totalExpenses += Number(ele.amount);
            } else if (ele.type == 0) {
              this.totalExpenses -= Number(ele.amount);
            }
          });

          //     totalUnitsCosts: 0,
          // totalEarth: 0,
          // totalExpenses: 0,
          // finalCalc: 0,

          // this.units = this.project.units;
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.project-units {
  padding: 10px;
  .project-header-stats {
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
  }
  .logs {
    .cell {
      padding: 10px;
    }
  }
  .total-logs {
    padding: 9px 43px;
    display: inline-block;
    background: #fff;
    margin-top: 14px;
    h6,
    h5 {
      text-align: center !important;
    }
  }
  .project-units-header {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .add-unit-search {
      display: flex;
      gap: 10px;
    }
  }

  .unit {
    padding: 14px;
    background: #fff;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #f7f7f7;
    margin-bottom: 15px;
    .head {
      gap: 10px;
      svg {
        padding: 5px;
        background-color: rgba(var(--vs-primary), 0.3) !important;
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
    }
    h6 {
      svg {
        path {
          fill: #ffcc33;
        }
      }
    }

    .unit-footer {
      display: flex;
      justify-content: space-between;
      .status {
        padding: 4px 10px;
        border-radius: 10px;
        font-weight: bold;
        &.danger {
          background-color: #ffd9d9;
          color: #ff2f2f;
        }
        &.success {
          background-color: #ecf7eb;
          color: #b8e0b6;
        }
      }
    }
  }
}

.search-in-expenses {
  width: 100% !important;
  .el-input__inner {
    width: 100% !important;
  }
}

@media (max-width: 500px) {
  .total-logs {
    width: 46%;
    padding: 9px 18px;
  }
}
</style>
